import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=71f1c82b&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=71f1c82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1c82b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f1c82b')) {
      api.createRecord('71f1c82b', component.options)
    } else {
      api.reload('71f1c82b', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=71f1c82b&scoped=true&", function () {
      api.rerender('71f1c82b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/forms/ResetPassword.vue"
export default component.exports